import { fetchWithAuth } from '../utils/fetchWithAuth';

export async function getUsers() {
  const response = await fetchWithAuth('/api/users');
  if (!response.ok) throw new Error('Failed to fetch users');
  return response.json();
}

export async function getMe() {
  const response = await fetchWithAuth('/api/user/me');
  if (!response.ok) throw new Error('Failed to fetch current user');
  return response.json();
}

export async function getPendingUsers() {
  const response = await fetchWithAuth('/api/users/pending');
  if (!response.ok) throw new Error('Failed to fetch pending users');
  return response.json();
}

export async function getUser(userId) {
  const response = await fetchWithAuth(`/api/users/${userId}`);
  if (!response.ok) throw new Error('Failed to fetch user');
  return response.json();
}

export async function updateUser(userId, patch) {
  const response = await fetchWithAuth(`/api/users/${userId}`, {
    method: 'PATCH',
    body: JSON.stringify(patch),
  });
  if (!response.ok) throw new Error('Failed to update user');
  return response.json();
}

export async function getUserOnboardingOptions() {
  const response = await fetchWithAuth('/api/users/onboarding-options');
  if (!response.ok) throw new Error('Failed to fetch onboarding options');
  return response.json();
}

// For editing existing users (no roles needed)
export async function getUserReferenceData() {
  const response = await fetchWithAuth('/api/users/reference-data');
  if (!response.ok) throw new Error('Failed to fetch reference data');
  return response.json();
}

export async function approvePendingUser(pendingId, payload) {
  const response = await fetchWithAuth(`/api/users/pending/${pendingId}/approve`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
  if (!response.ok) throw new Error('Failed to approve pending user');
  return response.json();
}

export async function rejectPendingUser(pendingId) {
  const response = await fetchWithAuth(`/api/users/pending/${pendingId}`, {
    method: 'DELETE',
  });
  if (!response.ok) throw new Error('Failed to reject pending user');
  return response.json();
}

export async function deleteUser(userId) {
  const response = await fetchWithAuth(`/api/users/${userId}`, {
    method: 'DELETE',
  });
  if (!response.ok) throw new Error('Failed to delete user');
  return response.json();
}